import { observable, makeObservable } from 'mobx';
import moment from 'moment';
import * as APITypes from "constants/API";
import QmsStorageKeys from 'constants/QmsStorageKeys';
import StorageKeys from 'constants/StorageKeys';
import axios from 'axios';
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from '../../../constants/Constants';
import getCookie from '../../../utils/journeyIdCookie/getJourneyId';

// !dummy Data

class QmsDetailsPageStore {
	seletedTabData = {};
	leadSpecificId = ""
	solutionId = ""
	showStartApplicationModal = false
	ulipTraining = false
	subStatusName = ""
	showSharePdfmodal = false
	sharePdfData = []
	showWspToolTip = false
	solutionTimelineData = {}

	constructor() {
		makeObservable(this, {
			seletedTabData: observable,
			leadSpecificId: observable,
			solutionId: observable,
			showStartApplicationModal: observable,
			ulipTraining: observable,
			subStatusName: observable,
			showSharePdfmodal: observable,
			sharePdfData: observable,
			showWspToolTip: observable,
			solutionTimelineData: observable,

		});
	}

	setShowWspToolTip(value) {
		this.showWspToolTip = value
	}

	setshowSharePdfmodal(value) {
		this.showSharePdfmodal = value
	}

	updateSelectedTabData(data) {
		this.seletedTabData = data
	}

	saveAgentDetails(agentData) {
		if (agentData) {
			sessionStorage.setItem(StorageKeys.AUTH_TOKEN, agentData.authToken)
			localStorage.setItem(QmsStorageKeys.AGENT_ID, agentData.agent_id)
			localStorage.setItem(QmsStorageKeys.PRAGATI_HOME_URL, agentData.pragati_home_url)
			localStorage.setItem(QmsStorageKeys.PRAGATI_POST_CALL_END_POINT_URL, agentData.pragati_post_call_end_point_url)
			localStorage.setItem(QmsStorageKeys.AGENT_CODE, agentData.agent_code)
			localStorage.setItem(QmsStorageKeys.AGENT_NAME, agentData.agent_name)
			localStorage.setItem(QmsStorageKeys.LOGIN_CODE, agentData.login_code)
			localStorage.setItem(QmsStorageKeys.VENDOR, agentData.vendor)
			localStorage.setItem(QmsStorageKeys.LOGIN_AGENT_CODE, agentData.login_agent_code)
			localStorage.setItem(QmsStorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM, agentData.first_time_optimization_page_load_param)
		}
	}

	fetchTabListData(list) {
		let tabList = []
		list.forEach((item, index) => {
			let previousVersionNumber = list.length - index;
			tabList.push({
				title: index == 0 ? "Latest Shared Version" : "Previous Version " + previousVersionNumber.toString(),
				subTitle1: `Soln ID:${item.solution_id} `,
				subTitle2: moment(item.pdf_shared_date).format("DD-MM-YYYY")
			})
		})
		return tabList
	}

	async startApplication(journeyId, solutionID) {

		this.solutionId = solutionID;
		//! comment for remove session	
		const response = await axios.post(APITypes.REFRESH_TOKEN);
		let refreshedToken = response.data.token;
		if (refreshedToken) {
			sessionStorage.setItem(StorageKeys.AUTH_TOKEN, refreshedToken);
		}

		let pragatiOutboundFormObj = document.getElementById("pragati-out-oubound-form-post-call");
		console.log("onPragatiOutboundClick formObj :: ", pragatiOutboundFormObj);
		this.onHideApplication();
		pragatiOutboundFormObj.submit();

		if (getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)) {
			sessionStorage.removeItem(COOKIE_PARA_NAME_FOR_JOURNEY_ID);
		}
		//  sessionStorage.removeItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE);
		//  sessionStorage.removeItem(StorageKeys.AUTH_TOKEN);

		// }
	}

	async onGenerateSolutionData(journeyId) {
		const generatedSolutionData = await this.createSolutionData(journeyId);
		if (generatedSolutionData && generatedSolutionData.data.length > 0) {
			return generatedSolutionData;
		}
		return [];
	}
	async createSolutionData(journeyId) {
		const response = await axios.get(APITypes.GENERATE_SOLUTION_DATA + journeyId + "/");
		return response;
	}

	onStartApplicationClick() {
		this.showStartApplicationModal = true
	}

	onHideApplication() {
		this.showStartApplicationModal = false
	}

	async fetchPdfUrl(proposerData, sourceFrom) {
		const response = await axios.post(APITypes.FETCH_SOLUTION_PDF_FROM_DMS,
			{
				"dms_id": proposerData.solution_dms_id
			});

		if (response.status === "success") {
			let proposerName = proposerData.proposer_salutation + " " + proposerData.proposer_first_name + " " + proposerData.proposer_middle_name + " " + proposerData.proposer_last_name
			this.downloadQuotePdf(response.data.pdf_url, proposerName, proposerData.solution_id, sourceFrom)
		}
	}

	downloadQuotePdf(url, proposerName, solutionId, sourceFrom) {
		if (sourceFrom === "Distribution_App") {
			window.open(url, "_blank");
		} else {
			fetch(url).then(r => r.blob()).then((blob) => {
				// Create blob link to download
				const url = window.URL.createObjectURL(
					new Blob([blob]),
				);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute(
					'download',
					`ELI Solution Presentation (${proposerName}) – ${solutionId}.pdf`,
				);

				// Append to html link element page
				document.body.appendChild(link);

				// Start download
				link.click();

				// Clean up and remove the link
				link.parentNode.removeChild(link);
			});
		}
	}

	fetchLaList(proposerData) {
		let laList = []
		proposerData?.coverage.forEach((coverageData) => {
			coverageData.life_assured_list.forEach((laData) => {
				let sameLA = laList.some((item) => item.la_family_member_id === laData.la_family_member_id)
				if (!sameLA) {
					laList.push(laData)
				} else {
					laList.forEach((item) => {
						if (item.la_family_member_id === laData.la_family_member_id) {
							item.product_details = [...item.product_details, ...laData.product_details]
						}
					})
				}
			})
		})
		return laList
	}

	async checkUlipTrainingFlag(journeyId) {
		const response = await axios.get(`${APITypes.AGENT_ULIP_TRAINING}?journey_id=${journeyId}`);
		this.ulipTraining = response.data.ulip_training;
		this.subStatusName = response.data?.substatus_name?.toLowerCase() || 'active';


		// this.ulipTraining = true
		// this.ulipTraining = false
		// this.subStatusName = 'active'
		// this.subStatusName = 'risk investigation'
		// this.subStatusName = 'impending'
	}
	async getWhatsAppMessageData(journeyId) {
		let agentID = localStorage.getItem(QmsStorageKeys.AGENT_CODE)

		const response = await axios.get(`${APITypes.SEND_WHATSAPP_MESSAGE}?journey_id=${journeyId}`);
		this.sharePdfData = response?.data?.pdf_data

		const responseData = await axios.get(
			`${APITypes.SHOW_COMPARE_PRODUCT_TOOLTIP}${agentID}?tooltip=${"WHATSAPP_TOOLTIP_DATE "}`
		)
		this.showWspToolTip = responseData?.data?.response === "true" ? true : false
	}

	async getSolutionTimeLinedata(proposerId) {
		let response = await  axios.post(APITypes.GET_SOLUTION_TIMELINE, {"proposer_id": proposerId})
		if (response.status === "success") {
			this.solutionTimelineData = response?.data
		}
	}

	async getSAMSApi(reqObj) {
		const response = await axios.post(APITypes.SAMS_API, reqObj)
		return response;
	}
}

export default new QmsDetailsPageStore();
